import './alternate-boxes.scss'
import { loadSvg } from 'js/utility/image.js'
import _ from 'lodash'

export default {
    name: 'alternate-boxes',

    data: {
        iconsSvg: [],
        observer: null
    },

    mounted () {
        this.loadIcons()

        this.observer = new IntersectionObserver(entries => {
            _.each(entries, entry => {
                if (entry.isIntersecting && entry.target.classList.contains('hidden')) {
                    entry.target.classList.remove('hidden')
                }
            })
        }, {
            rootMargin: '-10%'
        })
        _.each(this.$el.querySelectorAll('.alternate-boxes__box'), el => this.observer.observe(el))
    },

    methods: {
        loadIcons () {
            this.icons.forEach((url, i) => {
                if (url) {
                    loadSvg(url).then(svg => {
                        const cloneIconsSvg = _.clone(this.iconsSvg)
                        cloneIconsSvg[i] = svg.outerHTML
                        this.iconsSvg = cloneIconsSvg
                    })
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/alternate-boxes/alternate-boxes.js